export const CPTY_STATEMENTS_COLUMNS =
  'api/CounterpartyStatementConfig/statementcolumns';

export const CPTY_STATEMENT_CONFIG = 'api/CounterpartyStatementConfig';

export const UPLOADER_CPTY_STATEMENTS_COLUMNS =
  'api/CptyStatementUploaderConfig/statementcolumns';

export const UPLOADER_CPTY_STATEMENT_CONFIG = 'api/CptyStatementUploaderConfig';

export const MESSAGES = {
  REQUIRED_COUNTERPARTY: 'Counterparty is required',
  REQUIRED_STATEMENT_COLUMN: 'Statement Column is required',
  REQUIRED_START_DATE: 'Start Date is required',
  REQUIRED_VALUE: 'Value is required',
  REQUIRED_END_DATE: 'End Date is required',
  REQUIRED_ZKEY: 'Zkey is required',
  CPTY_STATEMENT_CONFIG_ADDED:
    'Counterparty Statement Config added successfully',
  CPTY_STATEMENT_CONFIG_ADDED_FAILED:
    'Error adding Counterparty Statement Config',
  CPTY_STATEMENT_CONFIG_MODIFIED:
    'Counterparty Statement Config updated successfully',
  CPTY_STATEMENT_CONFIG_MODIFIED_FAILED:
    'Error updating Counterparty Statement Config',
};
